import React, { useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { cancelSelectMode } from '~data/actions/bookmarks'

import { Button, Icon } from '~ui'

export default function BookmarksHeaderSelectModeCancel({ selectMode = {} }) {
    const dispatch = useDispatch()

    const onCancelSelectModeClick = useCallback(
        e => {
            e.preventDefault()
            dispatch(cancelSelectMode(selectMode.spaceId))
        },
        [dispatch, selectMode.spaceId]
    )

    return (
        <Button
            variant='ghost'
            title={t.s('cancel')}
            onClick={onCancelSelectModeClick}>
            <Icon name='close' />
            <span className='hide-on-small-body'>{t.s('cancel')}</span>
        </Button>
    )
}
